import { render } from "./arki-home-view.vue?vue&type=template&id=f7476c42"
import script from "./arki-home-view.vue?vue&type=script&setup=true&lang=js"
export * from "./arki-home-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/arki/home/arki-home-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f7476c42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f7476c42', __exports__)) {
    api.reload('f7476c42', __exports__)
  }
  
  module.hot.accept("./arki-home-view.vue?vue&type=template&id=f7476c42", () => {
    api.rerender('f7476c42', render)
  })

}


export default __exports__